<template>
  <div class="modal is-active" v-if="modal.show">
    <div class="modal-background" @click="handleCloseModal"></div>
    <div class="modal-card animated has-width-auto">
      <!-- Header Begins -->
      <slot name="header">
        <header class="modal-card-head">
          <span class="close-btn" v-if="showCloseBtn" @click="handleCloseModal">
            <img src="/static/img/cross.svg" alt="close">
          </span>
          <p class="modal-card-title">{{ title }}</p>
          <p v-if="smallTitle" class="modal-card-small-title" v-html="smallTitle"></p>
        </header>
      </slot>
      <!-- Header Ends -->
      <section class="modal-card-body has-text-centered">
        <slot name="body">
          <p> {{ body }} </p>
        </slot>
      </section>
      <slot name="footer">
        <!-- Footer Desktop Begins -->
        <footer class="modal-card-foot is-hidden-mobile">
          <!-- Dual buttons with static Cancel button -->
          <div class="level-item has-text-centered">
            <button
              class="button hollow-btn is-uppercase"
              @click="handlePrimaryAction"
              v-if="!showNoButtons"
            >
              {{ primaryBtnText }}
            </button>
            <button
              class="button solid-btn is-uppercase"
              @click.prevent="handleSecondaryAction"
              v-if="!showNoButtons"
            >
              {{ secondaryBtnText }}
            </button>
          </div>
        </footer>
        <!-- Footer Desktop Ends -->
        <!-- Footer Mobile Begins -->
        <footer class="columns modal-card-foot is-hidden-tablet is-hidden-desktop">
          <div class="column is-half">
            <button
              class="button hollow-btn is-uppercase"
              @click="handlePrimaryAction"
              v-if="!showNoButtons"
            >
              {{ primaryBtnText }}
            </button>
          </div>
          <div class="column is-half">
            <button
              class="button solid-btn is-uppercase"
              @click.prevent="handleSecondaryAction"
              v-if="!showNoButtons"
            >
              {{ secondaryBtnText }}
            </button>
          </div>
        </footer>
        <!-- Footer Mobile Ends -->
      </slot>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc */
import {mapState, mapActions} from 'vuex'
import {SHOW_MODAL} from '@/store/action.types'

export default {
  name: 'ModalPopup',
  props: {
    title: {
      default: 'Default Title'
    },
    body: {
      default: 'Default body'
    },
    primaryBtnText: {
      default: 'CANCEL'
    },
    secondaryBtnText: {
      default: 'OKAY'
    },
    smallTitle: {
      default: ''
    },
    primaryBtnAction: {
      type: Function
    },
    secondaryBtnAction: {
      type: Function
    },
    showNoButtons: {
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    },
    onBlur: {
      type: Function
    }
  },
  data () {
    return {
      isProcessing: false
    }
  },
  computed: {
    ...mapState({
      modal: state => state.app.modal
    })
  },
  methods: {
    ...mapActions({
      'showModal': `app/${SHOW_MODAL}`
    }),
    /**
     * Handler for primary button action
     * @return {void}
     */
    handlePrimaryAction () {
      if (this.primaryBtnAction) {
        this.primaryBtnAction()
      }
      this.showModal(false)
    },
    /**
     * Handler for secondary button action
     * @return {void}
     */
    handleSecondaryAction () {
      if (this.secondaryBtnAction) {
        this.secondaryBtnAction()
      }
    },
    /**
     * Close modal globally
     * @return {void}
     */
    handleCloseModal () {
      if (this.onBlur) {
        this.onBlur()
      }
      this.showModal(false)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.modal-card-head, .modal-card-foot {
  border-bottom: none;
  border-right: none;
  border-left: none;
  border-radius: 0;
  text-align: center;
  background-color: #fff;
  display: block;
}

.modal-card-foot {
  border: none;
}

.modal-card-body {
  text-align: left;
  background-color: #fff;
  font-size: .9em;
  padding: 0 20px;
}

.modal-card-head {
  border-top: 5px solid color('blue-dark');
  padding-top: 30px;
}

.modal-card-title {
  color: color('blue-dark');
  font-weight: bold;
}

.modal-card-small-title {
  margin-top: 10px;
}

.level-item {
  display: flex;
}

.close-btn {
  display: flex;
  cursor: pointer;
  background: #fff;
  align-items: flex-end;
  justify-content: flex-end;
}

section.modal-card-body > ul > li {
  margin-left: 32px;
  margin-right: 32px;
}

section.modal-card-body > ul > li {
  padding-bottom: 25px;
}

section.modal-card-body > ul > li:not(:last-child) {
  border-bottom: 1px solid #cccccc;
}

section.modal-card-body > ul > li:not(:first-child) {
  padding-top: 25px;
}

input[type="radio"]:checked {
  background-color: color('blue');
  border: 1px solid color('blue');
}

input[type="text"] {
  border-radius: 0;
  box-shadow: none !important;
  border: 1px solid #dbdbdb;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  max-width: 100%;
  width: 100%;
}

input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  width: 18px;
  height: 18px;
  padding: 3px;
  background-clip: content-box;
  border: 1px solid #d5d3d3;
  background-color: #fff;
  border-radius: 50%;
  vertical-align: middle;
}

.level-left > .level-item:first-child {
  margin-right: 0 !important;
  margin-left: 20px;
}

span.biz_input, span.biz_input input {
  width: 100%;
}

.dropdown.biz_select div {
  width: 100% !important;
  border-radius: 5px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 0px;
}

.dropdown.biz_select .dropdown-trigger {
  display: block !important;
}

.dropdown.biz_select {
  display: block;
}

.dropdown.biz_select .dropdown-menu {
  overflow-y: scroll;
  height: 200px;
  position: relative;
}

.margin-top-10 a {
  text-decoration: underline;
}

.modal-background {
  background-color: rgba(88, 89, 91, 0.4);
}

/*Media Queries Begin*/
@media screen and (min-width: 768px), print {
  .modal-content, .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: 400px !important;
  }
}

@media screen and (max-width: 767px) {
  .modal-background {
    background-color: rgba(88, 89, 91, 0.4);
  }
  .modal-card-head {
    padding-top: 20px;
  }
  .modal-card-foot {
    display: inline-flex;
  }
}

/*Media Queries End*/
</style>



// WEBPACK FOOTER //
// src/components/ModalPopup.vue